<template>
<div class="pdf-box">
<el-dialog title="巡回日报打印信息" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="90%" :before-close="cancle"
			top="10vh">
  <div class="main">
     <!-- <iframe width="100%" height="500" src="http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf" frameborder="0" ></iframe> -->
     <iframe width="100%" height="500" :src="src" frameborder="0" ></iframe>
  </div>
</el-dialog>
</div>
</template>

<script>


export default {
  name: "home",
  data() {
    return {
      src:
        // "http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf",
        '',
      dialogVisible:false,
  
    };
  },
  mounted(){
     
  },
  methods: {
      init(url){
          this.dialogVisible = true
          this.src = url

      },
    
    // 取消
    cancle() {
        this.dialogVisible = false
        this.$emit("getList")
    },
  }
};
</script>

<style lang="scss" scoped>
.pdf-box{
    /deep/ .el-dialog__body{
      width: 100%;
      height: 500px;
      padding: 0 !important;
      box-sizing: border-box;
      overflow-x: auto;
    }
}

.main {
  width:100%;
  height: 100%;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
}
</style>
